<script>
import CrudListVue from 'Support/components/crud/CrudList.vue';
import DataTableDateColumnVue from 'Support/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import ReportRequest from 'Domain/reports/ReportsRequest';
import ReportListStatusVue from './components/ReportListStatus.vue';
import ReportListTypeVue from './components/ReportListType.vue';
import ReportTerminateListVue from './components/ReportTerminateList.vue';

export default {
  name: 'ReportList',
  extends: CrudListVue,
  data() {
    return {
      requestClass: ReportRequest,
      hideEdit: true,
      hideDelete: true,
      headers: [
        {
          text: this.$t('support.components.reports.list.headers.id'),
          value: 'id',
        },
        {
          text: 'QTD. Registros',
          value: 'quantidadeRegistros',
        },
        {
          text: this.$t('support.components.reports.list.headers.status'),
          value: 'status',
          component: ReportListStatusVue,
        },
        {
          text: this.$t('support.components.reports.list.headers.tipo'),
          value: 'tipo',
          component: ReportListTypeVue,
        },
        {
          text: this.$t('support.components.reports.list.headers.dataInicioProcessamento'),
          value: 'dataInicioProcessamento',
          component: DataTableDateColumnVue,
        },
        {
          text: this.$t('support.components.reports.list.headers.dataFimProcessamento'),
          value: 'dataFimProcessamento',
          component: DataTableDateColumnVue,
        },
        {
          text: this.$t('support.components.reports.list.headers.action'),
          value: 'id',
          component: ReportTerminateListVue,
        },
      ],
    };
  },
};
</script>
